<template>
    <div class="cl_collapse">
        <el-collapse v-model="activeNames" @change="handleChange">
            <el-collapse-item 
                v-for="(item, index) in collapseList"
                :title="item.title" 
                :name="index"
            >
                <div class="collapse_content">
                    {{ `您本月帐单 存储${item.store}、录制${item.record}、充值${item.recharge}` }}
                </div>
            </el-collapse-item>
        </el-collapse>
    </div>
</template>

<script>
export default {
    name: 'cl-collapse',
    props: {
        collapseList: {
            type: Array,
            default: () => [
                {
                    title: '1月账单',
                    store: '-600A',
                    record: '-700A',
                    recharge: '123A',
                },
                {
                    title: '2月账单',
                    store: '-600A',
                    record: '-700A',
                    recharge: '123A',
                },
                {
                    title: '3月账单',
                    store: '-600A',
                    record: '-700A',
                    recharge: '123A',  
                }
            ]
        }
    },
    data() {
        return {
            activeNames: []
        }
    },
    methods: {
        handleChange(val) {
            console.log(val);
        }
    }
    // watch: {
    //     value(val) {
    //         this.collapse = val
    //     },
    //     collapse(val) {
    //         this.$emit('input', val)
    //     }
    // }
}
</script>

<style lang="scss" scoped>

</style>